import omit from "lodash/omit";

import {
  ADD_FILTER, DELETE_FILTER, SET_FILTERS
} from "./constants";


const initialState = {};


export default (state = initialState, action) => {
  switch (action.type) {

    case ADD_FILTER:
      return { ...state, [action.payload.filterName]: {
        ...state[action.payload.filterName],
        ...action.payload.filterConfig
      }};

    case SET_FILTERS:
      return { ...state, [action.payload.filterName]: action.payload.filterConfig};

    case DELETE_FILTER:
      return { ...state, [action.payload.filterName]: omit(state[action.payload.filterName], [action.payload.filterKey])};

    default:
      return state;
  }
};
